import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { CountdownTimerFixedWidthText } from './countdownTimerFixedWidthText';
function addZeroIfNeeded(num) {
    return num < 10 ? `0${num}` : `${num}`;
}
function getHoursAndMinutesString(secondsRemaining) {
    const fullMinutesRemaining = Math.floor(secondsRemaining / 60);
    if (fullMinutesRemaining < 60) {
        return `${fullMinutesRemaining}`;
    }
    const fullHoursRemaining = Math.floor(fullMinutesRemaining / 60);
    const minutesRemainingThisHour = fullMinutesRemaining % 60;
    return `${fullHoursRemaining}:${addZeroIfNeeded(minutesRemainingThisHour)}`;
}
function getSecondsRemainingNow(endTimestampMs) {
    const msRemaining = endTimestampMs - performance.now();
    if (msRemaining <= 0) {
        return;
    }
    return Math.floor(msRemaining / 1000);
}
export const CountdownTimerDisplay = ({ endTimestampMs, onTimerEnd, color, digitWidth }) => {
    const [secondsRemaining, setSecondsRemaining] = useState(getSecondsRemainingNow(endTimestampMs));
    const intervalId = useRef();
    const cancelInterval = () => {
        if (intervalId.current !== undefined) {
            clearInterval(intervalId.current);
            intervalId.current = undefined;
        }
    };
    const updateTimer = useCallback(() => {
        setSecondsRemaining(getSecondsRemainingNow(endTimestampMs));
    }, [endTimestampMs]);
    useEffect(() => {
        updateTimer(); // do initial update immediately rather than waiting a second
        intervalId.current = setInterval(updateTimer, 1000);
        return () => {
            cancelInterval();
        };
    }, [updateTimer]);
    useEffect(() => {
        if (secondsRemaining === undefined) {
            // timer done
            cancelInterval();
            onTimerEnd?.();
        }
    }, [onTimerEnd, secondsRemaining]);
    const containerCss = useMemo(() => css(css `
          user-select: none;
          pointer-events: none;
        `, color
        ? css `
              color: ${color};
            `
        : undefined), [color]);
    const displayedSecondsRemaining = secondsRemaining || 0;
    const secondsRemainingThisMinute = displayedSecondsRemaining % 60;
    const hoursAndMinutesString = getHoursAndMinutesString(displayedSecondsRemaining);
    const timerStr = `${hoursAndMinutesString}:${addZeroIfNeeded(secondsRemainingThisMinute)}`;
    return (_jsx("span", { css: containerCss, "data-seconds-remaining": displayedSecondsRemaining, children: digitWidth !== undefined ? (_jsx(CountdownTimerFixedWidthText, { timerStr: timerStr, digitWidth: digitWidth })) : (timerStr) }));
};
